import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-user-provider-plans',
  templateUrl: './user-provider-plans.component.html',
  styleUrl: './user-provider-plans.component.css'
})
export class UserProviderPlansComponent {

  userPlans: any = [];
  loading: boolean = false;

  constructor(
    private data: DataserviceService,
    private app: AppComponent
  ) {}

  ngOnInit() {
    this.loading = true;
    this.getPlans()
    if(this.hasPermissions('see_all_provider_user_plans')) {
      this.getPlans();
    }else {
      this.getCompanyPlans();
    }
  }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  getPlans() {
    this.data.getData(`provider-payplans/all-users-plans`)
      .subscribe({
        next: (res: any) => {
          this.userPlans = res;
          this.loading = false;
        }
      })
  }

  getCompanyPlans() {
    this.data.getData(`provider-payplans/company-users-plans`)
      .subscribe({
        next: (res: any) => {
          this.userPlans = res;
          this.loading = false;
        }
      })
  }

  statusPlan(plan: any) {
    console.log(plan)
  }

}
